import { FIELDS, TABS, TAB_VIEW_SECTIONS } from '../../../constants';

export const { AFFORDABLE } = TABS;
export const { AFFORDABLE_OVERVIEW, INCOME_ELIGIBILITY } =
  TAB_VIEW_SECTIONS[AFFORDABLE];
export const { DETAILS } = FIELDS[AFFORDABLE][AFFORDABLE_OVERVIEW];
export const { MAXIMUM_INCOME, OCCUPANTS } =
  FIELDS[AFFORDABLE][INCOME_ELIGIBILITY];

export const ENABLED = 'enabled';

export const MAX_DETAILS_LENGTH = 1000;
export const MAX_OCCUPANTS = 8;

export const FIELD_LABELS = {
  [DETAILS]: 'Program Description',
  [OCCUPANTS]: 'Occupants',
  [MAXIMUM_INCOME]: 'Maximum Income',
};

export const PLACEHOLDERS = {
  [DETAILS]:
    'Provide an overview of the program, including any guidelines, eligibility criteria, or rent restrictions.',
};

export const VALIDATION_ERROR_MESSAGES = {
  CHARACTER_LIMIT_EXCEEDED: 'Character limit exceeded',
  REQUIRED: 'required',
};
